import Tone from 'tone';
import EffectsChain from 'effects/EffectsChain.js';
import ParameterContext from 'effects/ParameterContext.js';

export default class MasterChannel {
    constructor(sequencerEngine) {
        this.sequencerEngine = sequencerEngine;
        this.output = new Tone.Volume();
        this.input = new Tone.Gain(1);

        this.effectsChain = new EffectsChain(
            this.input , this.output,
            new ParameterContext().forSend(this),
            sequencerEngine);

        this.effectsChain.setupEffects();
    }

    getJson() {
        return this.effectsChain.getJson();
    }

    fromJson(json) {
        this.effectsChain.clear();
        this.effectsChain.fromJson(json, this.sequencerEngine.tracks);
    }

    dispose() {
        this.output.dispose();
        this.input.dispose();
        this.effectsChain.dispose();
        this.output = undefined;
        this.input = undefined;
        this.effectsChain = undefined;
    }

    disconnect(n) {
        this.output.disconnect(n);
    }

    connect(node) {
        this.output.connect(node);
    }

    addEffect(effect) {
        this.effectsChain.addEffect(effect);
        this.effectsChain.linkEffectParameters();
    }

    moveEffectTo(effectFrom, effectTo) {
        this.effectsChain.moveEffectTo(effectFrom, effectTo);
    }

    deleteEffect(effect) {
        this.effectsChain.deleteEffect(effect);
    }

    copyFrom(masterChannel) {
        this.effectsChain.fromJson(
            masterChannel.effectsChain.getJson(),
            undefined,
            undefined,
            true);
    }
}
